"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _airbnbPropTypes = require("airbnb-prop-types");
var _propTypes2 = require("@agillic/prop-types");
var _formattedDate = require("./formattedDate.helper");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var FormattedDate = function FormattedDate(_ref) {
  var date = _ref.date,
    dateFormat = _ref.dateFormat,
    locale = _ref.locale,
    localeFormat = _ref.localeFormat,
    isErrorMessageHidden = _ref.isErrorMessageHidden,
    isTooltipVisible = _ref.isTooltipVisible;
  return _react.default.createElement("time", {
    dateTime: new Date(date).toISOString(),
    title: isTooltipVisible ? dateFormat : null
  }, (0, _formattedDate.getFormattedDate)({
    date: date,
    dateFormat: dateFormat,
    locale: locale,
    localeFormat: localeFormat,
    isErrorMessageHidden: isErrorMessageHidden
  }));
};
FormattedDate.propTypes = {
  date: _propTypes.number.isRequired,
  dateFormat: (0, _airbnbPropTypes.and)([_propTypes.string, (0, _propTypes2.forbiddenBy)('locale'), _propTypes2.notOnlyWhiteSpace]),
  locale: (0, _airbnbPropTypes.and)([_propTypes.string, (0, _propTypes2.forbiddenBy)('dateFormat'), (0, _propTypes2.requiredBy)('localeFormat')]),
  localeFormat: (0, _airbnbPropTypes.and)([_propTypes.string, (0, _propTypes.oneOf)(['time', 'date', 'datetime']), (0, _propTypes2.forbiddenBy)('dateFormat'), (0, _propTypes2.requiredBy)('locale')]),
  isErrorMessageHidden: _propTypes.bool,
  isTooltipVisible: _propTypes.bool
};
var _default = FormattedDate;
exports.default = _default;